import React, { Component } from 'react';
import Layout from '../components/layout';
import Logo from '../components/logo';
import SCREENS_GAMEIF from '../assets/images/screens-gameif.png';
import PLAY_ICON from '../assets/images/play.svg';
import Footer from '../components/footer';
import Counter from '../components/counter';

class Home extends Component {

  countdownCompletedHandler = () => {
    this.props.startRound();
  }
  

  _renderActions = () => {
    if (this.props.started) {
      return (
        <div className="game-rounds">
          <p>Ronda {this.props.round}<br/> Comienza en</p>
          <Counter onCompleted={this.countdownCompletedHandler} />
        </div>
      );
    } else {
      return (
        <div className="game-rounds">
          <button className="play-button" onClick={this.props.startGame}>
            <img src={PLAY_ICON} alt="iniciar" />
          </button>
          <p>Haz clic en el botón para comenzar la ronda</p>
        </div>
      );
    }
  }

  render() {
    return (
      <Layout>
        <div className="cover-page">
          <div className="container">
            <div className="header">
              <Logo campaign={this.props.campaign.name} />
            </div>
            <div className="greeting">{`Hola ${this.props.username}`}</div>
            <p>{this.props.campaign.description}</p>
            <div className="banner-gameif">
              <img src={SCREENS_GAMEIF} alt="Gameif" />
            </div>
            { this._renderActions() }
            <Footer />
          </div>
        </div>
      </Layout>
    );
  }
}

export default Home;